import React from "react";
import { Laptop, ShieldCheck, Boxes, Truck } from "lucide-react";

export default function Login() {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white" data-testid="login-page">
      {/* Left: form */}
      <div className="flex flex-col justify-between px-8 sm:px-14 lg:px-20 py-10">
        <div className="flex items-center gap-2.5">
          <div className="h-10 w-10 rounded-md bg-[#0A2540] flex items-center justify-center">
            <Laptop className="h-5 w-5 text-white" />
          </div>
          <div>
            <p className="font-heading font-extrabold text-[#0F172A] leading-none text-lg">PC Panda</p>
            <p className="text-xs text-slate-500 tracking-wide">TECHNOLOGIES</p>
          </div>
        </div>

        <div className="max-w-md">
          <p className="text-sm font-semibold text-emerald-600 tracking-wide uppercase mb-3">
            Rental Operations Portal
          </p>
          <h1 className="font-heading font-extrabold text-4xl sm:text-5xl tracking-tight text-[#0F172A] leading-[1.05]">
            Manage every laptop &amp; desktop you rent out.
          </h1>
          <p className="mt-5 text-slate-600 text-base leading-relaxed">
            A single source of truth for your master inventory, client deliveries and
            return tracking. Sign in with your Google account to continue.
          </p>

          <button
            onClick={handleLogin}
            data-testid="google-login-button"
            className="mt-8 inline-flex items-center justify-center gap-3 w-full sm:w-auto rounded-md bg-[#0A2540] px-7 py-3.5 text-white font-semibold hover:bg-[#1E3A5F] active:scale-[0.98] transition-[background-color,transform] duration-150"
          >
            <svg className="h-5 w-5" viewBox="0 0 24 24">
              <path fill="#fff" d="M12 11v2.8h4a3.9 3.9 0 0 1-1.7 2.6l2.7 2.1c1.6-1.5 2.5-3.6 2.5-6.2 0-.6-.1-1.1-.2-1.6H12z" opacity=".0" />
              <path fill="#EA4335" d="M12 5.3c1.5 0 2.9.5 4 1.5l3-3A9.9 9.9 0 0 0 12 1 11 11 0 0 0 2.2 7l3.5 2.7C6.5 7.1 9 5.3 12 5.3z" />
              <path fill="#4285F4" d="M22 12.2c0-.7-.1-1.4-.2-2H12v3.9h5.6a4.8 4.8 0 0 1-2.1 3.1l3.3 2.6c2-1.8 3.2-4.5 3.2-7.6z" />
              <path fill="#FBBC05" d="M5.7 14.3a6.6 6.6 0 0 1 0-4.6L2.2 7A11 11 0 0 0 1 12c0 1.8.4 3.5 1.2 5l3.5-2.7z" />
              <path fill="#34A853" d="M12 23c2.7 0 5-.9 6.7-2.4l-3.3-2.6c-.9.6-2 1-3.4 1-3 0-5.5-1.8-6.4-4.4L2.2 17A11 11 0 0 0 12 23z" />
            </svg>
            Continue with Google
          </button>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4">
            {[
              { icon: Boxes, label: "Master Inventory" },
              { icon: Truck, label: "Delivery Tracking" },
              { icon: ShieldCheck, label: "Return Logging" },
            ].map((f) => (
              <div key={f.label} className="flex items-center gap-2 text-slate-600 text-sm">
                <f.icon className="h-4 w-4 text-[#0A2540]" />
                {f.label}
              </div>
            ))}
          </div>
        </div>

        <p className="text-xs text-slate-400">© {new Date().getFullYear()} PC Panda Technologies. All rights reserved.</p>
      </div>

      {/* Right: image */}
      <div className="hidden lg:block relative bg-slate-900">
        <img
          src="https://images.pexels.com/photos/15940010/pexels-photo-15940010.jpeg"
          alt="Workspace"
          className="absolute inset-0 h-full w-full object-cover opacity-90"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A2540]/80 via-[#0A2540]/20 to-transparent" />
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <p className="font-heading font-bold text-2xl leading-snug">
            Track hundreds of rental units without a single spreadsheet headache.
          </p>
        </div>
      </div>
    </div>
  );
}
